// Painel do funil da Rede Everlog (PO1-3649, épico PO1-3359): regras puras da
// tela: as etapas na ordem do contrato (seção 6), agrupadas em blocos para os
// cards, tom de cada uma, formatação e link para a curadoria. Sem React.

export const ROTA_CURADORIA = "/app/everlog/curadoria-transportadoras";
export const DIAS_PADRAO = 90;

// Chaves das etapas, na ordem do contrato. `rotulo` é o fallback quando a API
// não manda o dela.
export const ETAPAS = [
  { chave: "pedidos", rotulo: "Pedidos", bloco: "entrada", tom: "info", icone: "tim-icons icon-paper" },
  { chave: "convites", rotulo: "Convites", bloco: "entrada", tom: "info", icone: "tim-icons icon-email-85" },
  { chave: "em_curadoria", rotulo: "Em curadoria", bloco: "entrada", tom: "warning", icone: "tim-icons icon-time-alarm" },
  { chave: "recusados", rotulo: "Recusados", bloco: "entrada", tom: "pink", icone: "tim-icons icon-simple-remove" },
  { chave: "aceitos", rotulo: "Aceitos", bloco: "entrada", tom: "success", icone: "tim-icons icon-check-2" },
  { chave: "habilitadas", rotulo: "Habilitadas", bloco: "cadastro", tom: "info", icone: "tim-icons icon-badge" },
  { chave: "homologadas", rotulo: "Homologadas", bloco: "cadastro", tom: "success", icone: "tim-icons icon-trophy" },
  { chave: "com_cobertura", rotulo: "Com cobertura", bloco: "cadastro", tom: "info", icone: "tim-icons icon-map-big" },
  { chave: "com_tabela", rotulo: "Com tabela", bloco: "cadastro", tom: "neutral", icone: "tim-icons icon-notes" },
  { chave: "com_api", rotulo: "Com API", bloco: "cadastro", tom: "neutral", icone: "tim-icons icon-link-72" },
  { chave: "aparicoes_tela", rotulo: "Aparições na tela", bloco: "demanda", tom: "info", icone: "tim-icons icon-zoom-split" },
  { chave: "aparicoes_leilao", rotulo: "Aparições no leilão", bloco: "demanda", tom: "info", icone: "tim-icons icon-zoom-split" },
  { chave: "aparicoes_bid", rotulo: "Aparições no BID", bloco: "demanda", tom: "info", icone: "tim-icons icon-zoom-split" },
  { chave: "convites_leilao", rotulo: "Convites de leilão", bloco: "leilao", tom: "info", icone: "tim-icons icon-send" },
  { chave: "lances_leilao", rotulo: "Lances", bloco: "leilao", tom: "warning", icone: "tim-icons icon-money-coins" },
  { chave: "vitorias_leilao", rotulo: "Vitórias no leilão", bloco: "leilao", tom: "success", icone: "tim-icons icon-trophy" },
  { chave: "convites_bid", rotulo: "Convites de BID", bloco: "bid", tom: "info", icone: "tim-icons icon-send" },
  { chave: "propostas_bid", rotulo: "Propostas", bloco: "bid", tom: "warning", icone: "tim-icons icon-paper" },
  { chave: "vencedoras_bid", rotulo: "Vencedoras no BID", bloco: "bid", tom: "success", icone: "tim-icons icon-trophy" },
  { chave: "vinculadas_embarcador_real", rotulo: "Vinculadas por embarcador", bloco: "resultado", tom: "success", icone: "tim-icons icon-bank" },
];

export const BLOCOS = [
  { chave: "entrada", titulo: "Entrada", descricao: "Pedidos pela página pública, convites, curadoria e aceite do termo." },
  { chave: "cadastro", titulo: "Cadastro", descricao: "Habilitação, homologação e o que a transportadora declarou: cobertura, tabela e API." },
  { chave: "demanda", titulo: "Demanda", descricao: "Quantas vezes transportadoras da Rede apareceram para embarcadores, por contexto." },
  { chave: "leilao", titulo: "Leilão", descricao: "Convites, lances e vitórias de transportadoras da Rede." },
  { chave: "bid", titulo: "BID", descricao: "Convites, propostas e vencedoras de transportadoras da Rede." },
  { chave: "resultado", titulo: "Resultado", descricao: "Transportadoras da Rede que um embarcador real vinculou à própria carteira." },
];

const POR_CHAVE = ETAPAS.reduce((acc, e) => {
  acc[e.chave] = e;
  return acc;
}, {});

export const etapaDe = (chave) => POR_CHAVE[chave] || { chave, rotulo: chave, bloco: "outros", tom: "neutral" };
export const rotuloEtapa = (chave) => etapaDe(chave).rotulo;

// Junta o que a API devolveu com a ordem do contrato: as conhecidas na ordem,
// as desconhecidas no fim (bloco "outros"), nenhuma perdida.
export function ordenarEtapas(etapasApi) {
  const lista = Array.isArray(etapasApi) ? etapasApi : [];
  const porChave = {};
  lista.forEach((e) => {
    if (e && e.chave) porChave[e.chave] = e;
  });
  const conhecidas = ETAPAS.map((def) => ({ ...def, rotulo: (porChave[def.chave] && porChave[def.chave].rotulo) || def.rotulo, total: Number(porChave[def.chave] && porChave[def.chave].total) || 0, parados: (porChave[def.chave] && porChave[def.chave].parados) || [] }));
  const extras = lista.filter((e) => e && e.chave && !POR_CHAVE[e.chave]).map((e) => ({ ...etapaDe(e.chave), rotulo: e.rotulo || e.chave, total: Number(e.total) || 0, parados: e.parados || [] }));
  return conhecidas.concat(extras);
}

export const etapasDoBloco = (etapas, bloco) => (etapas || []).filter((e) => e.bloco === bloco);

export const fmtNumero = (v) => (v === null || v === undefined ? "–" : String(Math.round(Number(v) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, "."));

// Tempo médio em dias, com uma casa; "–" sem dado.
export function fmtDias(v) {
  const n = Number(v);
  if (v === null || v === undefined || Number.isNaN(n)) return "–";
  if (n < 1) return `${Math.round(n * 24)} h`;
  return `${n.toFixed(1).replace(".", ",")} d`;
}

// Parado há quantos dias, a partir de `desde` (ISO) e de agora.
export function diasDesde(desde, agora) {
  if (!desde) return null;
  const t = new Date(desde).getTime();
  if (Number.isNaN(t)) return null;
  const ref = agora != null ? agora : Date.now();
  return Math.max(0, Math.floor((ref - t) / 86400000));
}

// Link para a curadoria quando o parado tem idConvite (busca pelo CNPJ).
export function linkCuradoria(parado) {
  if (!parado || !parado.idConvite) return null;
  const q = String(parado.cnpj || "").replace(/\D/g, "") || String(parado.nome || "");
  return `${ROTA_CURADORIA}?status=todos&q=${encodeURIComponent(q)}`;
}
